"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pendingUploadsReducer = exports.mapTransferStateToPackageState = exports.initialState = void 0;
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* Package Imports */
var immutable_1 = require("immutable");
var moment_1 = __importDefault(require("moment"));
var typesafe_actions_1 = require("typesafe-actions");
/* Blast Imports */
var actions = __importStar(require("./actions"));
var models_1 = require("@app/_state/models");
var transfersActions = __importStar(require("@app/features/transfers/state/actions"));
var api_1 = require("@server/types/api");
exports.initialState = {
    pendingUploads: immutable_1.OrderedMap()
};
/* Complimentary Reducer Functions - begin */
var mapTransferStateToPackageState = function (state) {
    switch (state) {
        case api_1.State.IN_PROGRESS:
        case api_1.State.POST_PROCESSING:
            return models_1.PackageTransferState.IN_PROGRESS;
        case api_1.State.COMPLETE:
            return models_1.PackageTransferState.COMPLETE;
        case api_1.State.FAILED:
        case api_1.State.EXPIRED:
            return models_1.PackageTransferState.FAILED;
        default:
            return models_1.PackageTransferState.FAILED;
    }
};
exports.mapTransferStateToPackageState = mapTransferStateToPackageState;
var mapTransferStateToModel = function (transferState) {
    var state = exports.mapTransferStateToPackageState(transferState.state);
    return {
        direction: transferState.direction,
        state: state,
        packageId: transferState.packageId,
        retryable: (transferState.retryable) ? transferState.retryable : false,
        size: transferState.packageTotalSize,
        transferredBytes: (state === models_1.PackageTransferState.COMPLETE) ? transferState.packageTotalSize : 0,
        title: transferState.title,
        creationDate: moment_1.default(transferState.createdAt).format()
    };
};
/* Complimentary Reducer Functions - end */
var pendingUploadsReducer = function (state, action) {
    if (state === void 0) { state = exports.initialState; }
    switch (action.type) {
        // Transfer actions
        case (typesafe_actions_1.getType(actions.clearPendingTransfers)):
            return __assign(__assign({}, state), { pendingUploads: immutable_1.OrderedMap() });
        case (typesafe_actions_1.getType(transfersActions.forwardPackageSuccess)): { // TODO: Remove in case we don't want Forwards to be in pending list
            var createdDate = new Date();
            var forwardTransfer = {
                packageId: action.payload.id,
                state: models_1.PackageTransferState.COMPLETE,
                title: action.payload.title,
                size: 1,
                direction: api_1.Direction.SEND,
                transferredBytes: 1,
                creationDate: createdDate.toJSON()
            };
            var newPendingUploadFPS = immutable_1.OrderedMap();
            newPendingUploadFPS = newPendingUploadFPS.set(forwardTransfer.packageId, forwardTransfer);
            return __assign(__assign({}, state), { pendingUploads: newPendingUploadFPS.merge(state.pendingUploads) });
        }
        case (typesafe_actions_1.getType(transfersActions.httpUploadSuccess)): {
            var newPendingUploadHUS = immutable_1.OrderedMap();
            newPendingUploadHUS = newPendingUploadHUS.set(action.payload.packageId, mapTransferStateToModel(action.payload));
            return __assign(__assign({}, state), { pendingUploads: newPendingUploadHUS.merge(state.pendingUploads) });
        }
        case (typesafe_actions_1.getType(actions.refreshPendingTransfersSuccess)):
            var newPendingUploadsRPTS_1 = immutable_1.OrderedMap();
            action.payload.sort(function (a, b) { return a.createdAt && b.createdAt ? moment_1.default(b.createdAt).diff(a.createdAt) : 0; }).map(function (t) { return newPendingUploadsRPTS_1 = newPendingUploadsRPTS_1.set(t.packageId, mapTransferStateToModel(t)); });
            return __assign(__assign({}, state), { pendingUploads: newPendingUploadsRPTS_1 });
        case (typesafe_actions_1.getType(transfersActions.remoteTransferSuccess)): // Acts the exact same way Forwards do
        case (typesafe_actions_1.getType(transfersActions.retryHttpUploadRequest)): {
            var newPendingUploadsRHUR_1 = state.pendingUploads;
            newPendingUploadsRHUR_1.valueSeq().toArray().forEach(function (t) {
                if (t.packageId === action.payload) {
                    newPendingUploadsRHUR_1 = newPendingUploadsRHUR_1.set(action.payload, __assign(__assign({}, t), { state: models_1.PackageTransferState.IN_PROGRESS }));
                }
            });
            return __assign(__assign({}, state), { pendingUploads: newPendingUploadsRHUR_1 });
        }
        case (typesafe_actions_1.getType(transfersActions.updateTransfer)): {
            // Ignore downloads
            if (action.payload.direction === api_1.Direction.RECEIVE) {
                return state;
            }
            var newPendingUploadUT = void 0;
            var currentPendingUpload = state.pendingUploads.get(action.payload.packageId);
            if (action.payload.packageId && currentPendingUpload) {
                newPendingUploadUT = {
                    packageId: currentPendingUpload.packageId,
                    title: currentPendingUpload.title,
                    direction: currentPendingUpload.direction,
                    size: action.payload.totalSize,
                    transferredBytes: action.payload.transferredBytes,
                    state: action.payload.state,
                    creationDate: action.payload.creationDate,
                    errorCode: action.payload.errorCode,
                    errorDesc: action.payload.errorDesc,
                    retryable: action.payload.retryable,
                    transferId: action.payload.transferId
                };
                var newPendingUploadsUT = state.pendingUploads;
                newPendingUploadsUT = newPendingUploadsUT.set(action.payload.packageId, newPendingUploadUT);
                return __assign(__assign({}, state), { pendingUploads: newPendingUploadsUT });
            }
            else {
                newPendingUploadUT = {
                    direction: api_1.Direction.SEND,
                    packageId: action.payload.packageId || '0',
                    size: action.payload.totalSize,
                    state: action.payload.state,
                    title: action.payload.title,
                    transferredBytes: action.payload.transferredBytes,
                    creationDate: action.payload.creationDate,
                    errorCode: action.payload.errorCode,
                    errorDesc: action.payload.errorDesc,
                    retryable: action.payload.retryable,
                    transferId: action.payload.transferId
                };
                var newPendingUploadMapUT = immutable_1.OrderedMap();
                newPendingUploadMapUT = newPendingUploadMapUT.set(newPendingUploadUT.packageId, newPendingUploadUT);
                return __assign(__assign({}, state), { pendingUploads: newPendingUploadMapUT.merge(state.pendingUploads) });
            }
        }
        default:
            return state;
    }
};
exports.pendingUploadsReducer = pendingUploadsReducer;
